export default __webpack_public_path__ + "static/media/alemana-color.d8889687.svg";